<div class="wrapper__contentComponent--expediente container my-5">
  <!-- Main panel -->
  <ng-container *ngIf="listFlag">
    <div class="d-flex justify-content-between align-items-center mb-3">
      <h2>Lista de roles</h2>
      <button
        id="crearRol"
        class="btn-govco fill-btn-govco hvr-shrink ms-2"
        (click)="crearRol()">
        <span class="govco-svg govco-plus-circle me-2"></span>
        Crear rol
      </button>
    </div>
    <div class="d-flex justify-content-between mb-3">
      <p class="justify-text">
        En el contexto de agentes cognitivos racionales, un rol se refiere a una
        función o conjunto de comportamientos específicos que un agente asume
        dentro de un entorno determinado para cumplir con sus objetivos.
      </p>
    </div>
    <div class="d-flex justify-content-end mb-3">
      <div class="input-group w-50">
        <input
          type="text"
          class="form-control"
          placeholder="Buscar por nombre"
          [(ngModel)]="searchTerm" />
        <span class="input-group-text">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="currentColor"
            class="bi bi-search"
            viewBox="0 0 16 16">
            <path
              d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.415l-3.85-3.85a1.007 1.007 0 0 0-.115-.098zm-5.442 1.398a5.5 5.5 0 1 1 0-11 5.5 5.5 0 0 1 0 11z" />
          </svg>
        </span>
      </div>
    </div>
    <!-- Tabla de roles -->
    <div class="table-container" *ngIf="roles.length > 0; else noData">
      <table class="table table-striped table-bordered">
        <thead class="custom-header">
          <tr>
            <th>Nombre</th>
            <th class="display-none">Estado</th>
            <th class="display-none">Fecha Modificación</th>
            <th class="display-none">Usuario</th>
            <th>Acciones</th>
          </tr>
        </thead>
        <tbody>
          <tr
            *ngFor="
              let rol of roles
                | filter: searchTerm : 'Nombre'
                | paginate: { itemsPerPage: 5, currentPage: currentPage }
            "
            class="hover-effect">
            <td>{{ rol.Nombre }}</td>
            <td class="display-none">{{ rol.Estado }}</td>
            <td class="display-none">
              {{ rol.FechaModificacion | date: 'yyyy-MM-dd HH:mm' }}
            </td>
            <td class="display-none">{{ rol.UsuarioModificacion }}</td>
            <td class="btns-box">
              <button
                class="btn btn-sm btn-outline-primary"
                (click)="onRowClick(rol)">
                Ver
              </button>
              <button
                class="btn btn-sm btn-outline-primary"
                (click)="editarRol(rol)">
                Editar
              </button>
              <button
                class="btn btn-sm btn-outline-primary"
                (click)="eliminarRol(rol.Id)">
                Eliminar
              </button>
            </td>
          </tr>
        </tbody>
      </table>
      <!-- Pagination Controls -->
      <pagination-controls
        (pageChange)="currentPage = $event"
        previousLabel="Anterior"
        nextLabel="Siguiente"
        class="d-flex justify-content-center mt-3">
      </pagination-controls>
    </div>
    <!-- Plantilla para mostrar mensaje si no hay datos -->
    <ng-template #noData>
      <div class="no-data-container">
        <p>{{ mensaje }}</p>
      </div>
    </ng-template>
  </ng-container>
  <!-- Read panel -->
  <ng-container *ngIf="readFlag">
    <div class="d-flex justify-content-between align-items-center mb-3">
      <h2>Formulario de Rol</h2>
      <button
        id="detalleRol"
        class="btn-govco fill-btn-govco hvr-shrink ms-2"
        (click)="volverElemento()">
        <span class="govco-svg govco-arrow-circle-left me-2"></span>
        Volver a elemento
      </button>
    </div>
    <form [formGroup]="rolForm" (ngSubmit)="submitForm()">
      <div class="row">
        <div *ngFor="let field of nomDesForm" class="col-md-{{ field.width }}">
          <div class="mb-3">
            <label
              *ngIf="
                field.name != 'herramienta' ||
                (field.name === 'herramienta' && this.isTools)
              "
              [for]="field.name"
              class="form-label"
              >{{ field.label
              }}<span
                *ngIf="field.required"
                _ngcontent-ng-c3465959523=""
                class="text-danger">
                *</span
              ></label
            >
            <!-- Text Input -->
            <input
              *ngIf="field.type === 'text'"
              [id]="field.name"
              [type]="field.type"
              class="form-control"
              [formControlName]="field.name"
              [readonly]="isReadOnly" />
            <!-- Textarea -->
            <quill-editor
              *ngIf="field.type === 'textarea1'"
              [id]="field.name"
              class="form-control"
              [formControlName]="field.name"
              [modules]="quillConfig"
              placeholder="Ingresa el texto aquí..."></quill-editor>
            <!-- Select Dropdown -->
            <select
              *ngIf="field.type === 'select1'"
              [id]="field.name"
              class="form-select"
              [formControlName]="field.name"
              [disabled]="isReadOnly">
              <option *ngFor="let option of estados" [value]="option">
                {{ option }}
              </option>
            </select>
            <!-- Select Dropdown -->
            <select
              *ngIf="field.type === 'select2'"
              [id]="field.name"
              class="form-select"
              [formControlName]="field.name"
              [disabled]="isReadOnly"
              (change)="onChangeEquipo($event)">
              <option *ngFor="let option of equipos" [value]="option.Id">
                {{ option.Nombre }}
              </option>
            </select>
            <!-- Select Dropdown -->
            <select
              *ngIf="field.type === 'select3'"
              [id]="field.name"
              class="form-select"
              [formControlName]="field.name"
              [disabled]="isReadOnly">
              <option *ngFor="let base of basesConocimiento" [value]="base.Id">
                {{ base.Nombre }}
              </option>
            </select>
            <!-- Select Dropdown -->
            <select
              *ngIf="field.type === 'select4' && isTools"
              [id]="field.name"
              class="form-select"
              [formControlName]="field.name"
              [disabled]="isReadOnly">
              <option
                *ngFor="let herramienta of herramientas"
                [value]="herramienta.Id">
                {{ herramienta.Nombre }}
              </option>
            </select>
            <!-- Textarea -->
            <quill-editor
              *ngIf="field.type === 'textarea2'"
              [id]="field.name"
              class="form-control"
              [formControlName]="field.name"
              [modules]="quillConfig"
              placeholder="Ingresa el texto aquí..."></quill-editor>
            <!-- Textarea -->
            <quill-editor
              *ngIf="field.type === 'textarea3'"
              [id]="field.name"
              class="form-control"
              [formControlName]="field.name"
              [modules]="quillConfig"
              placeholder="Ingresa el texto aquí..."></quill-editor>
            <!-- Validation Error Messages -->
            <div *ngIf="getErrorMessage(field.name)" class="text-danger">
              {{ getErrorMessage(field.name) }}
            </div>
          </div>
        </div>
      </div>
      <!-- Ejemplo de conducta -->
      <div class="row">
        <div
          class="d-flex justify-content-between align-items-center mb-3 mt-5">
          <h4 class="wrapper__form__title mb-0">Ejemplo de conducta</h4>
          <button
            type="button"
            id="crearEjemplo"
            *ngIf="!isReadOnly"
            class="btn-govco fill-btn-govco hvr-shrink ms-2"
            (click)="crearEjemplo()">
            <span class="govco-svg govco-plus-circle me-2"></span>
            Crear ejemplo
          </button>
        </div>
      </div>
      <div class="row">
        <!-- Recorrer la lista de ejemplos -->
        <div
          class="container m-2 ejemplos-box"
          *ngIf="ejemplos.length > 0; else noData">
          <div *ngFor="let ejemplo of ejemplos">
            <app-ejemplo
              [ejemplo]="ejemplo"
              [nivel]="0"
              [isReadOnly]="isReadOnly"
              (actualizar)="onEjemploActualizar($event)"
              (eliminar)="onEjemploEliminar($event)">
            </app-ejemplo>
          </div>
        </div>
        <ng-template #noData>
          <div class="no-data-container">
            <p>Sin ejemplo</p>
          </div>
        </ng-template>
      </div>
      <!-- Ejemplo de conducta: Controles -->
      <div class="mt-3 d-flex gap-2">
        <button
          type="button"
          class="btn-govco fill-btn-govco"
          (click)="toggleEdit()"
          *ngIf="isReadOnly">
          Editar
        </button>
        <button
          type="submit"
          class="btn-govco fill-btn-govco"
          *ngIf="!isReadOnly">
          Guardar
        </button>
        <button
          type="button"
          class="btn-govco btn-govco"
          (click)="toggleEdit()"
          *ngIf="!isReadOnly">
          Cancelar
        </button>
      </div>
      <!-- Modelo de dialogo -->
      <ng-container *ngIf="dilogModelFlag">
        <div class="row">
          <div
            class="d-flex justify-content-between align-items-center mb-3 mt-5">
            <h4 class="wrapper__form__title mb-0">Modelo de díalogo</h4>
            <button
              type="button"
              id="crearInteraccion"
              *ngIf="!isReadOnly"
              class="btn-govco fill-btn-govco hvr-shrink ms-2"
              (click)="crearInteraccion()">
              <span class="govco-svg govco-plus-circle me-2"></span>
              Crear interacción
            </button>
          </div>
        </div>
        <div class="row">
          <p>
            La dinámica del modelo de diálogo se basa en la interacción entre
            las descripciones de las acciones del usuario y las instrucciones
            dirigidas al agente cognitivo.
          </p>
        </div>
        <div class="row">
          <div class="container mt-4">
            <!-- Recorrer la lista de interacciones -->
            <div *ngFor="let interaccion of interacciones">
              <app-interaccion
                [interaccion]="interaccion"
                [nivel]="0"
                [isReadOnly]="isReadOnly"
                (seleccionado)="onInteraccionSeleccionada($event)"
                (agregar)="onInteraccionAgregar($event)"
                (actualizar)="onInteraccionActualizar($event)"
                (eliminar)="onInteraccionEliminar($event)">
              </app-interaccion>
            </div>
          </div>
        </div>
        <!-- Modelo de dialogo: Controles -->
        <div class="mt-3 d-flex gap-2">
          <button
            type="button"
            class="btn-govco fill-btn-govco"
            (click)="toggleEdit()"
            *ngIf="isReadOnly">
            Editar
          </button>
          <button
            type="submit"
            class="btn-govco fill-btn-govco"
            *ngIf="!isReadOnly">
            Guardar
          </button>
          <button
            type="button"
            class="btn-govco btn-govco"
            (click)="toggleEdit()"
            *ngIf="!isReadOnly">
            Cancelar
          </button>
        </div>
      </ng-container>
    </form>
  </ng-container>
</div>
<!-- Modales -->
<div *ngIf="modalNDFlag">
  <app-modal-nom-des [elements]="roles" (ndEmitter)="registrarRol($event)">
  </app-modal-nom-des>
</div>
<div *ngIf="modalInteraccionFlag">
  <app-modal-interaccion
    [isTools]="isTools"
    [listaEquipos]="listaEquipos"
    [herramientas]="herramientas"
    [editFlag]="editIneraccionFlag"
    [vertices]="vertices"
    [interaccion]="interaccionSeleccionada"
    (interaccionEmitter)="adicionarInteraccion($event)"
    (updatedEmitter)="interaccionActualizada($event)">
  </app-modal-interaccion>
</div>
<div *ngIf="modalEjemploFlag">
  <app-modal-ejemplo
    [actor]="actorEjemplo"
    [editFlag]="editEjemploFlag"
    [ejemplo]="ejemploSeleccionado"
    (ejemploEmitter)="adicionarEjemplo($event)"
    (updatedEjemplo)="ejemploActualizado($event)">
  </app-modal-ejemplo>
</div>
